export enum AttendingChoice {
  No = "No",
  Yes = "Yes",
}
